
























import { Component, Vue } from "vue-property-decorator";

@Component
class TradeStatementModal extends Vue {
  dialog = false;

  notDisplay = false;

  mounted() {
    const showTradeStatementModal = this.$store.state.trade
      .showFiatTradeStatementModal;
    if (showTradeStatementModal) {
      this.dialog = true;
    }
  }

  handleConfirm() {
    if (this.notDisplay) {
      this.$store.commit("trade/SET_SHOW_FIAT_TRADE_STATEMENT_MODAL", false);
    }
    this.dialog = false;
  }
}
export default TradeStatementModal;
